 
import React from 'react';

import ReactDOM from 'react-dom';


import { Menu, Button } from '@jd/find-react';
import KeeVue from '../base/KeeVue.js'


const { SubMenu } = Menu;
 

export default class FsRouter extends KeeVue {
  constructor(props) {
    super(props); 
    this.state = {
      collapsed: false,
	  defaultOpenKeys:[],
      selectedKeys: [],
      menus: []
    }
  }

  componentWillMount() {
    this.registComponent();
    this.initData();
    var that = this;
    window.onpopstate = function (state, title, url) {
	// alert("rooter onpopstate:"+url);
      that.onHashChange();
    }
	
	this.onEvent("HashChange",(url,params)=>{ 
		//alert("rooter的hashchange收到事件"+url);
		this.openHashSp(url,params);
		this.$emit("HashChange",url,params); 
	});
	
  }

 
  initData = () => { 
		 if(window.mainInfo&&window.mainInfo.success&&window.mainInfo.retData.menus)
		 {
		 	let ret = JSON.parse(window.mainInfo.retData.menus);
		 	
		 	  if (ret && ret.menus) {
		 		  
		 		  // 处理 icon，二级及以下菜单不要图标
		 		 ret.menus.map((item,index)=>{
		 			 if(item.children)
		 			 {
		 				 item.children.map((item2)=>{
		 					 item2.icon="";
		 					 if(item2.children)
		 					 {
		 					 				 item2.children.map((item3)=>{
		 					 					 item3.icon="";
		 					 					 
		 					 				 })
		 					 }
		 				 })
		 			 }
		 		 });
		 		  
		 	    this.state.menus = ret.menus;
		 		this.onHashChange();
		 	    this.refresh();
		 	  } 
		 }
		 else
		 {
		  
		 	    this.state.menus = [];
		 		this.onHashChange();
		 	    this.refresh();
		 	  
		 }

  }
 
	findUrlFromNodes=(nodes, path)=> {
				if(nodes != null) {
					console.log()
					for(var i = 0; i < nodes.length; i++) {

						// 判断提交 
						//if(nodes[i].path == path) 
						if(path.indexOf(nodes[i].id+"_")==0) 
						{
							// 是这个节点

							// this.selectMenu(this.menuNodes, nodes[i]);

							// this.updateMenuState(nodes[i]);
							
							this.state.selectedKeys.push(nodes[i].id);
							
						
							
							return nodes[i];
							
						} else {

							if(nodes[i].children != null) {
								
								var src = this.findUrlFromNodes(nodes[i].children, path);
								if(src != null) {
									this.state.defaultOpenKeys.push(nodes[i].id);
									return src;
								}
							}
						}
					}
				}
				return null;

			}
  onHashChange = () => {

    var that = this;

    var hash = "";
    // hash 为 #xxx 格式

    hash = window.location.hash;
    hash = hash.replace('#', '');


    if (window.history.state && window.history.state.sp) {
      hash = window.history.state.sp;
    }
	
	if(this.getQueryVariable("sp"))
	{
		hash = this.getQueryVariable("sp");
	}

	this.state.selectedKeys = [];
	this.state.defaultOpenKeys=[];

    that.currentHash = hash;

    console.log("检测到hash值变更：：：：：" + hash);

    var node = that.findUrlFromNodes(that.state.menus, hash);
	
	//return nodes[i].attributes.src;
	var src = null;
	if(node)
	{
		var path =  hash.replace(node.id+"_","");
		
		if(path.indexOf("!routerjson")!=-1)
		{	
			 path = path.substring(0,path.indexOf("!routerjson"));
		}
		src = path;
	}
	else
	{
		// 如果是表单页面，可以直接展示，由表单控制渲染逻辑
		 
		src=hash;
	}
	
	
	// 如果找不到这个菜单，则跳转到默认的第一个菜单；如果是表单页面或者是应用管理页面，则直接显示，应用页面需要判断权限
	

    console.log("找到src：" + src + "   path：" + hash)
 

   
  //  alert("相应hash值：" + hash)

    // this.currentUrl = src;
	if(src)
	{
		//alert("src:"+src);
		this.$emit("HashChange",src,node);
	} 
	else
	{
		//alert("src wei kong");
	}
	this.refresh();

  }
  
  

  onSelect = (obj) => {
    //alert(JSON.stringify(obj.key));
    var targetMenuItem = this.getMenuItem(this.state.menus, obj.key);
    if (targetMenuItem) {
      
	  this.openHashSp(targetMenuItem.path);
	  this.state.selectedKeys = [];
	  this.state.selectedKeys.push(targetMenuItem.id);
	  this.onHashChange();
    }
	this.refresh();
  }

  getMenuItem = (menus, key) => {
    for (var i = 0; i < menus.length; i++) {
      if (menus[i].id === key) {
        return menus[i];
      }
      if (menus[i].children && menus[i].children.length > 0) {
        var target = this.getMenuItem(menus[i].children, key);

        if (target) {
          return target;
        }
      }
    }
    return null;
  }

  openHashSp = (sp,pdata) => {

    // 参数处理

    var params = "";
    var url = window.location.href;
 
    var urls = url.split("?");

    var existsSp = false;
    if (urls.length > 1) {
      var arr = urls[1].split("&");
      for (var i = 0, l = arr.length; i < l; i++) {
		  
		 if(!arr[i])
		 {
			 continue;
		 }
		  
        var a = arr[i].split("=");
		
		if(params)
		{
			params+="&";
		}

        if (a[0] == "sp") {
          existsSp = true;
          params += a[0] + "=" + sp;
        }
        else {
          params +=  a[0] + "=" + a[1];
        }
      }
    }

    if (!existsSp) {
      if (params) {
        params = "sp=" + sp + "&" + params;
      }
      else {
        params = "sp=" + sp;
      }

    }
	
	if(pdata&& typeof pdata!='string'&&typeof pdata=='object')
	{
		for(var p in pdata)
		{
			 params +="&"+p+"="+pdata[p];
		}
	}



    window.history.pushState({ sp: sp }, "", "?" + params);

    // 触发一次变更，fs-view 修改了当前url，通过值的绑定来更新
    //this.onHashChange();

  }
 

  render() {
 
    return (

<div>  </div>


    );
  }
}

